module.exports = __webpack_public_path__ + "img/CM-NL-CA-Mitsubishi-Playful.dd75d892.png";